import store from 'services/store';
import setAuthInitStatus from '../actions/setAuthInitStatus';

const setAuthInitSuccess = async () => await store.dispatch(setAuthInitStatus('success'));

export default setAuthInitSuccess;
